import * as a1lib from "alt1";
import { EwentHandler } from "../reactive";
import { FakeLodash } from "../coreutil/FakeLodash";
export class Alt1MainHotkeyEvent {
    constructor() {
        this.handlers = [];
        this.trigger_count = 0;
        a1lib.on("alt1pressed", e => {
            this.clean_pass();
            const event = new Alt1MainHotkeyEvent.Event(e);
            const sorted = FakeLodash.sortBy(this.handlers.filter(h => h.isAlive()), h => -h.priority);
            for (const handler of sorted) {
                handler.apply(event);
                if (event.isConsumed())
                    break;
            }
        });
    }
    clean_pass() {
        this.trigger_count += 1;
        if (this.trigger_count > 10) {
            this.handlers = this.handlers.filter(s => s.isAlive());
        }
    }
    /**
     * Subscribe to the main hotkey event
     * @param priority The priority of this handler. Handlers with higher priorities see the event first and can stop propagation.
     * @param handler The handler function.
     */
    subscribe(priority, handler) {
        this.clean_pass();
        let h = new Alt1MainHotkeyEvent.Handler(priority, handler);
        this.handlers.push(h);
        return h;
    }
}
(function (Alt1MainHotkeyEvent) {
    class Handler extends EwentHandler {
        constructor(priority, handler) {
            super(handler);
            this.priority = priority;
        }
    }
    Alt1MainHotkeyEvent.Handler = Handler;
    class Event {
        constructor(raw) {
            this.raw = raw;
            this.consumed = false;
            this.mouse = raw.mouseRs;
            this.mouseScreen = raw.mouseAbs;
            this.text = raw.text.length > 0 ? raw.text : null;
        }
        consume() {
            this.consumed = true;
            return this;
        }
        isConsumed() {
            return this.consumed;
        }
    }
    Alt1MainHotkeyEvent.Event = Event;
})(Alt1MainHotkeyEvent || (Alt1MainHotkeyEvent = {}));
